export default __webpack_public_path__ + "static/media/school-erp.e841d601.png";